import { render, staticRenderFns } from "./tableOrders.vue?vue&type=template&id=7a8eafaa&scoped=true"
import script from "./tableOrders.vue?vue&type=script&lang=js"
export * from "./tableOrders.vue?vue&type=script&lang=js"
import style0 from "./tableOrders.vue?vue&type=style&index=0&id=7a8eafaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8eafaa",
  null
  
)

export default component.exports